(() => {
  const loaded = new Map();
  function load(src) {
    if (loaded.has(src)) return loaded.get(src);
    const task = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = resolve;
      script.onerror = () => { loaded.delete(src); script.remove(); reject(new Error('Component failed to load')); };
      document.head.append(script);
    });
    loaded.set(src, task);
    return task;
  }
  function scan(scope) {
    const markers = [...scope.querySelectorAll('[data-doi-component-src]')];
    if (scope.matches?.('[data-doi-component-src]')) markers.unshift(scope);
    for (const marker of markers) {
      const src = marker.dataset.doiComponentSrc;
      if (src) load(src).catch(() => {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
